export default {
    query: {
        form_fixed: true
    },
    table: {
        border: true,
        stripe: true,
        align: 'center'
    },
    localeList: [
        {value: 'zhCn', label: '简体中文'},
        {value: 'en', label: 'English'}
    ],
    watermark: {
        enable: true,
        color: 'rgba(192,192,192,.4)',
    }
}

